import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { getVerifyMailDataFailure, getVerifyMailDataSuccess, verifyMailDataRequest } from "../slice/newsletterVerifyEmailSlice";
const SUBSCRIBE_RESET_URL = "common/subscription/verify-mail";
const fetchSubscribeResetData = async subscribePayload => {
  const headerData = {
    headers: {
      "Content-Type": "application/json"
    },
    loader: true
  };
  const response = await api.post(SUBSCRIBE_RESET_URL, subscribePayload, headerData);
  return response;
};
function* getVerifyMailData(action) {
  try {
    const response = yield call(fetchSubscribeResetData, action.payload);
    yield put(getVerifyMailDataSuccess(response.data));
  } catch (error) {
    yield put(getVerifyMailDataFailure(error));
  }
}
export function* watchVerifyMailData() {
  yield takeLatest(verifyMailDataRequest.type, getVerifyMailData);
}